// extracted by mini-css-extract-plugin
export default {"inputContainer":"k0MLpUiQd9oB3awqtydd__inputContainer___","suggestions":"QCykgPNKInPgtlvu24nc__suggestions___","searchDropdown":"IHYCfF9TKQ2gbYa5EKK6__searchDropdown___"};